import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=b5fe1234&"
import script from "./DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports